import { Link } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';

import NavData from '@/config/data/nav/nav_data.json';
import analytics from '../../../firebase';
import { sendLogData } from '../../common/common_fnc';
import useContent from '@/localization/data_export';

export function CommonLatest({ episode = null, detailData = [] }) {
  const anchorTitle = useContent(['global', 'anchor', 'title']);

  if (!episode || episode.length === 0) return <div>자료가 없습니다...</div>;
  else
    return (
      <ul className="list-wrap">
        {episode.map((v) => {
          let titleData = detailData.filter((el) => el.episode_id === v.episode_id);
          if (v.broadcast_date)
            return (
              <li className="list" key={`latest_${v.episode_id}`}>
                <Link
                  to={`${NavData['VOD_VIEW'].path}/?id=${v.episode_id}&board=${v.board_id}&sort=latestVod`}
                  className="link"
                  onClick={() => sendLogData({ title: v.title, id: v.episode_id, type: 'episode' })}
                  title={anchorTitle}
                >
                  <div className="link_img-warp">
                    {v.image_url ? (
                      <img
                        src={`${v.image_url}`}
                        alt=""
                        className="img"
                        onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                      />
                    ) : (
                      <img className="img" alt="" src={require('@/assets/images/icon/672_379_A.png').default} />
                    )}
                  </div>
                  <h3 className="link_title">{v.title}</h3>
                  <div className="link_subtitle">
                    <p className="program">{titleData?.[0]?.bis_program_code?.[0].bis_program_title}</p>
                    <p className="broadcast time-fs-fixed">
                      {v?.broadcast_date ? v?.broadcast_date?.slice(0, 10) : v?.reg_date?.slice(0, 10)}
                    </p>
                  </div>
                </Link>
              </li>
            );
          else return false;
        })}
      </ul>
    );
}

export function CommonPopular({ epiPopular = null, detailData = [] }) {
  const anchorTitle = useContent(['global', 'anchor', 'title']);

  if (!epiPopular || epiPopular.item.length === 0) return <div>자료가 없습니다...</div>;
  else
    return (
      <ul className="list-wrap">
        {epiPopular.item.map((v, i) => {
          let titleData = detailData.filter((el) => el.episode_id === v.episode_id);
          if (v.broadcast_date)
            return (
              <li className="list" key={`popular_${v.episode_id}`}>
                <Link
                  to={`${NavData['VOD_VIEW'].path}/?id=${v.episode_id}&board=${v.board_id}&sort=popularVod`}
                  className="link"
                  onClick={() => sendLogData({ title: v.title, id: v.episode_id, type: 'episode' })}
                  title={anchorTitle}
                >
                  <div className="link_img-warp">
                    {v.image_url ? (
                      <img
                        src={`${v.image_url}`}
                        className="img"
                        alt=""
                        onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                      />
                    ) : (
                      <img className="img" alt="" src={require('@/assets/images/icon/672_379_A.png').default} />
                    )}
                  </div>
                  <h3 className="link_title">{v.title}</h3>
                  <div className="link_subtitle">
                    <p className="program">{titleData?.[0]?.bis_program_code?.[0].bis_program_title}</p>
                    <p className="broadcast time-fs-fixed">{v?.broadcast_date?.slice(0, 10)}</p>
                  </div>
                </Link>
              </li>
            );
          else return false;
        })}
      </ul>
    );
}

export function CommonRecommand({ recommendList = null, detailData }) {
  const anchorTitle = useContent(['global', 'anchor', 'title']);

  return (
    <ul className="list-wrap">
      {recommendList?.map((v, i) => {
        let titleData = detailData?.filter((el) => el.episode_id === v?.episodes?.[0]?.episode_id);
        return (
          <li className="list" key={v.board_item_id}>
            {v.url_link?.[0] ? (
              <a
                href={v.url_link[0]}
                className="link"
                onClick={() =>
                  logEvent(analytics, 'select_item', {
                    item_list_name: `${v.title}`,
                    item_list_id: `vod_${v.episodes?.[0]?.episode_id}`,
                    items: [
                      {
                        item_id: `${v.episodes?.[0]?.episode_id}`,
                        item_name: `${v.title}`,
                        item_brand: 'vod',
                      },
                    ],
                  })
                }
                title={anchorTitle}
              >
                <div className="link_img-warp">
                  {v?.image?.url || v.episodes?.[0]?.image_url ? (
                    <img
                      src={v?.image?.url ? v.image.url : `${v.episodes?.[0]?.image_url}`}
                      alt=""
                      className="link_img boardData"
                      onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                    />
                  ) : (
                    <img className="img boardData" alt="" src={require('@/assets/images/icon/672_379_A.png').default} />
                  )}
                </div>
                <h3 className="link_title">{v.title}</h3>
                <div className="link_subtitle">
                  <p className="program">{titleData?.[0]?.bis_program_code?.[0].bis_program_title}</p>
                  <p className="broadcast time-fs-fixed">
                    {v?.episodes?.[0]?.broadcast_date ? v?.episodes?.[0]?.broadcast_date?.slice(0, 10) : ''}
                  </p>
                </div>
              </a>
            ) : (
              <Link
                to={
                  v.episodes?.[0]?.episode_id
                    ? `${NavData['VOD_VIEW'].path}/?id=${v.episodes?.[0]?.episode_id}&board=${v.board_id}&sort=recoVod`
                    : NavData['VOD_VIEW'].path
                }
                className="link"
                onClick={() =>
                  logEvent(analytics, 'select_item', {
                    item_list_name: `${v.title}`,
                    item_list_id: `vod_${v.episodes?.[0]?.episode_id}`,
                    items: [
                      {
                        item_id: `${v.episodes?.[0]?.episode_id}`,
                        item_name: `${v.title}`,
                        item_brand: 'vod',
                      },
                    ],
                  })
                }
                title={anchorTitle}
              >
                <div className="link_img-warp">
                  {v.episodes?.[0]?.image_url ? (
                    <img
                      src={`${v.episodes?.[0]?.image_url}`}
                      alt=""
                      className="link_img boardData"
                      onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                    />
                  ) : (
                    <img className="img boardData" alt="" src={require('@/assets/images/icon/672_379_A.png').default} />
                  )}
                </div>
                <h3 className="link_title">{v.title}</h3>
                <div className="link_subtitle">
                  <p className="program">{titleData?.[0]?.bis_program_code?.[0].bis_program_title}</p>
                  <p className="broadcast time-fs-fixed">
                    {v?.episodes?.[0]?.broadcast_date ? v?.episodes?.[0]?.broadcast_date?.slice(0, 10) : ''}
                  </p>
                </div>
              </Link>
            )}
          </li>
        );
      })}
    </ul>
  );
}
